import React from 'react';
import {
  Body1400N, TextRegularS
} from '../utilities/generatedClasses';
import { Button } from '@mui/material';

const ToastMessageCard = (props) => {
  const { dismiss, text } = props;

  return (
    <div className="wait-approval-toast-card">
      <p className={Body1400N}>
        {text}
      </p>
      <div style={{ textAlign: 'right' }}>
        <Button className={TextRegularS} onClick={dismiss}>
          Dismiss
        </Button>
      </div>

    </div>
  );
};

export default ToastMessageCard;
